module.exports = __webpack_public_path__ + "img/jack.18542737.jpg";